import { ApiType } from "@gymflow/common";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export function useMutationMigrationNewPassword(
  {
    api,
  }: {
    api: ApiType;
  },

  mutationOpts?: UseMutationOptions<
    void,
    unknown,
    { invitationToken: string; newPassword: string }
  >,
) {
  return useMutation({
    mutationFn: async ({
      invitationToken,
      newPassword,
    }: {
      invitationToken: string;
      newPassword: string;
    }) => {
      await api.public.hostedClubApi.invitationNewPassword({
        invitationToken,
        newPassword,
      });
    },

    ...mutationOpts,
  });
}
